module.exports = __webpack_public_path__ + "static/img/5.ca46b484.jpg";